"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("../../psp_driverlist/src/common");
var SupersedeMatrixList = /** @class */ (function (_super) {
    __extends(SupersedeMatrixList, _super);
    function SupersedeMatrixList(props) {
        var _this = _super.call(this, props) || this;
        _this.SupersedeMatrix = null;
        _this.versionLength = 0;
        _this.colWidth = 120;
        _this.colH1Width = undefined;
        _this.colH2Width = 120;
        _this.maxSubseriesLength = 0;
        _this.getDataTable = _this.getDataTable.bind(_this);
        _this.showSupersede = _this.showSupersede.bind(_this);
        window["SupersedeUpdate"] = function () { _this.forceUpdate(); };
        return _this;
    }
    SupersedeMatrixList.prototype.componentDidUpdate = function () {
        var that = this;
        if (that.versionLength > 0) {
            var html = $('.supersede-table').html();
            var d = $(html);
            d.find('.c').remove();
            d.css("position", "absolute");
            d.css("top", "0");
            d.removeAttr("id");
            $('.supersede-table-fix').empty().append(d[0]);
            var func = function () {
                $('.supersede-table-fix .table-supersedes').css("width", that.colH1Width + that.colH2Width + "px");
                var width = $('.dow-content-body').width() - that.colH1Width - that.colH2Width;
                if (that.versionLength * that.colWidth > width) {
                    $('.supersede-table .table-supersedes').css('width', '100%');
                    $('.version-name').css('left', ($('.supersede').width() + that.colH1Width + that.colH2Width) / 2);
                }
                else {
                    $('.supersede-table .table-supersedes').css('width', that.colH1Width + that.colH2Width + that.versionLength * that.colWidth + 'px');
                    $('.version-name').css('left', that.colH1Width + that.colH2Width + that.colWidth * that.versionLength / 2);
                }
            };
            func();
            $(window).resize(func);
        }
    };
    //for test
    SupersedeMatrixList.prototype.forTest = function (that) {
        that.SupersedeMatrix.Supersedes = that.SupersedeMatrix.Supersedes.concat(JSON.parse(JSON.stringify(that.SupersedeMatrix.Supersedes)));
        that.SupersedeMatrix.Supersedes = that.SupersedeMatrix.Supersedes.concat(JSON.parse(JSON.stringify(that.SupersedeMatrix.Supersedes)));
        that.SupersedeMatrix.Supersedes = that.SupersedeMatrix.Supersedes.concat(JSON.parse(JSON.stringify(that.SupersedeMatrix.Supersedes)));
        var i = 10;
        that.SupersedeMatrix.Supersedes = that.SupersedeMatrix.Supersedes.map(function (item) {
            item.Version = "1." + (i++);
            return item;
        });
    };
    SupersedeMatrixList.prototype.showSupersede = function (e) {
        var _this = this;
        var url = l.UrlUtility.getFullPath("/api/products/supersede/" + lmd.docID);
        var getParams = function () {
            if (/\/products\//i.test(location.pathname)) {
                return window['config'] && window['config'].product ? { Guid: window['config'].product.Guid, ParentGuids: window['config'].product.ParentGuids.join(',') } : {};
            }
            return {};
        };
        $(e.target).text("Loading..").removeClass("btn-primary").addClass("btn-default").addClass("disabled");
        $.ajax({
            type: 'post', cache: true, url: url, dataType: "json", data: getParams()
        }).done(function (data) {
            _this.SupersedeMatrix = data;
            //that.forTest(that);
            window["SupersedeMatrix"] = _this.SupersedeMatrix;
            _this.forceUpdate();
        }).fail(function (err) {
            console.log(err);
        });
    };
    SupersedeMatrixList.prototype.getDataTable = function () {
        var _this = this;
        if ((!this.SupersedeMatrix || this.SupersedeMatrix.error)) {
            console.log(this.SupersedeMatrix);
            return null;
        }
        var data = this.SupersedeMatrix;
        data.Supersedes.sort(function (a, b) {
            return -1 * a.Version.localeCompare(b.Version);
        });
        this.versionLength = data.Supersedes.length;
        data.Products.map(function (p) {
            p.Result = {};
            data.Supersedes.map(function (s, index) {
                p.Result[s.Version] = s.ProductGuid.indexOf(p.Guid) >= 0;
            });
        });
        // data.Products.sort((a, b)=>{
        //     return a.ParentName.localeCompare(b.ParentName);
        // });
        var srRows = [];
        for (var i = 0; i < data.Products.length; i++) {
            var p = data.Products[i];
            if (i == 0) {
                srRows.push({ p: p.ParentName, count: 1, list: [p] });
            }
            else {
                var preP = data.Products[i - 1];
                if (p.ParentName == preP.ParentName) {
                    srRows[srRows.length - 1].count++;
                    srRows[srRows.length - 1].list.push(p);
                }
                else {
                    srRows.push({ p: p.ParentName, count: 1, list: [p] });
                }
            }
        }
        var colHeaderStyle = { display: 'inline-flex', paddingLeft: "12px", paddingRight: "12px" };
        var lines = [];
        for (var i = 0; i < srRows.length; i++) {
            var row = srRows[i];
            var parent = row.p;
            var _loop_1 = function (j) {
                var L = row.list[j];
                var list = row.count > 1 && j > 0 ? [React.createElement("th", { className: "center" },
                        React.createElement("span", { style: colHeaderStyle }, L.Name))] : [React.createElement("th", { className: "left", rowSpan: row.count },
                        React.createElement("span", { style: colHeaderStyle }, parent)), React.createElement("th", { className: "center" },
                        React.createElement("span", { style: colHeaderStyle }, L.Name))];
                list = list.concat(data.Supersedes.map(function (item) { return React.createElement("td", { className: "c" },
                    React.createElement("span", null, item.ProductGuid.indexOf(L.Guid) > -1 ? '●' : ' ')); }));
                lines.push(React.createElement("tr", null, list));
            };
            for (var j = 0; j < row.count; j++) {
                _loop_1(j);
            }
        }
        var header1 = [React.createElement("th", { colSpan: 2, className: "flag-fix-width center bold" },
                React.createElement("span", null, "Product")), React.createElement("th", { className: "c", colSpan: data.Supersedes.length },
                React.createElement("span", { className: "version-name bold", style: { position: "absolute", top: "9px" } }, "Version"))];
        var header2 = [React.createElement("th", { className: "center bold" },
                React.createElement("span", { className: "headerStyleBolck", style: { width: this.colH1Width + "px" } }, "Subseries")), React.createElement("th", { className: "center bold" },
                React.createElement("span", { className: "headerStyleBolck", style: { width: this.colH2Width + "px" } }, "Machine Type"))];
        header2 = header2.concat(data.Supersedes.map(function (item) { return React.createElement("th", { className: "c" },
            React.createElement("a", { className: "headerStyleBolck", style: { width: _this.colWidth + "px" }, href: l.UrlUtility.getFullPath('/downloads/' + item.Id), target: "_blank", title: item.Version }, item.Version)); }));
        return React.createElement("table", { className: "table table-supersedes" },
            React.createElement("tbody", null,
                React.createElement("tr", null, header1),
                React.createElement("tr", null, header2),
                lines));
    };
    SupersedeMatrixList.prototype.render = function () {
        if (this.SupersedeMatrix) {
            for (var _i = 0, _a = this.SupersedeMatrix.Products; _i < _a.length; _i++) {
                var item = _a[_i];
                this.maxSubseriesLength = item.ParentName.length > this.maxSubseriesLength ? item.ParentName.length : this.maxSubseriesLength;
            }
            this.colH1Width = 0;
            if (this.maxSubseriesLength <= 10) {
                this.colH1Width = 120;
            }
            else if (this.maxSubseriesLength <= 14) {
                this.colH1Width = 150;
            }
            else if (this.maxSubseriesLength <= 18) {
                this.colH1Width = 200;
            }
            else {
                this.colH1Width = 250;
            }
            console.log('H1Width:' + this.colH1Width + ',MaxLength:' + this.maxSubseriesLength);
            return React.createElement("div", { className: "dow-content-body" },
                React.createElement("h3", null, l.Translator.translate("previous version|Previous Version")),
                React.createElement("div", { className: "supersede", style: { position: "relative" } },
                    React.createElement("div", { className: "supersede-table" }, this.getDataTable()),
                    React.createElement("div", { className: "supersede-table-fix" })));
        }
        else {
            return React.createElement("div", { className: "btn btn-primary", onClick: this.showSupersede }, "Show Supersede");
        }
    };
    return SupersedeMatrixList;
}(React.Component));
exports.SupersedeMatrixList = SupersedeMatrixList;
var SupersedeList = /** @class */ (function (_super) {
    __extends(SupersedeList, _super);
    function SupersedeList(props) {
        return _super.call(this, props) || this;
    }
    SupersedeList.prototype.render = function () {
        if (this.props != null && this.props.supersedes != null && this.props.supersedes.length > 0) {
            var linkStyle = {
                color: 'rgb(51, 51, 51)',
                cursor: 'default'
            };
            var linkSpanStyle = {
                float: 'right',
                'margin-right': '12px'
            };
            var supersedes = this.props.supersedes;
            var supersedesItems = [];
            supersedes.forEach(function (driver, idx) {
                supersedesItems.push(React.createElement(SupersedeItem, { supersede: driver }));
            });
            return (React.createElement("div", { className: "dow-content-body" },
                React.createElement("h3", null, l.Translator.translate("previous version|Previous Version")),
                React.createElement("table", { width: "100%" },
                    React.createElement("tr", null,
                        React.createElement("th", null, l.Translator.translate("Description|Description")),
                        React.createElement("th", null, l.Translator.translate("psp download severity|Severity")),
                        React.createElement("th", null, l.Translator.translate("psp download version|Version")),
                        React.createElement("th", null, l.Translator.translate("release date|Release date"))),
                    supersedesItems)));
        }
        else {
            return null;
        }
    };
    return SupersedeList;
}(React.Component));
exports.SupersedeList = SupersedeList;
var SupersedeItem = /** @class */ (function (_super) {
    __extends(SupersedeItem, _super);
    function SupersedeItem(props) {
        return _super.call(this, props) || this;
    }
    SupersedeItem.prototype.getUrl = function (tag) {
        var urlStr = "/downloads/" + tag;
        return l.UrlUtility.getFullPath(urlStr);
    };
    SupersedeItem.prototype.render = function () {
        if (this.props != null && this.props.supersede != null) {
            var supersedeDriver = this.props.supersede;
            return (React.createElement("tr", null,
                React.createElement("td", null,
                    React.createElement("a", { href: this.getUrl(supersedeDriver.Id) }, supersedeDriver.Name),
                    React.createElement("br", null)),
                React.createElement("td", null,
                    supersedeDriver.Priority,
                    React.createElement("br", null)),
                React.createElement("td", null,
                    supersedeDriver.Version,
                    React.createElement("br", null)),
                React.createElement("td", null, common_1.Utils.driverListDateTime(supersedeDriver.Date.Unix))));
        }
        else {
            return null;
        }
    };
    return SupersedeItem;
}(React.Component));
exports.SupersedeItem = SupersedeItem;
